'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.ProfileChart', 'AVRO.Widgets.ChartElements'];
module.exports = angular.module('AVRO.AdvancedProfileChart', dependencies).controller('AdvancedProfileChartController', require('./controllers/AdvancedProfileChartController')).directive('rmAdvancedProfileChart', require('./directives/AdvancedProfileChartDirective')).factory('AdvancedProfileChart', require('./factories/AdvancedProfileChart'));